<template>
  <div class="work-list">
    <div class="details-top">
      <form action="/" class="logo-container">
        <van-search v-model="searchContent" right-icon="" shape="round" placeholder="搜索内容" @search="onCourseSearchEnter"
          :clearable="true" clear-trigger="always" @clear="clearSearchValue">
          <template #left-icon>
            <van-icon name="search" />
          </template>
        </van-search>
      </form>
      <div class="sec-flex">
        <div :class="['flex-txt', active === item.code ? 'cur' : '']" v-for="item in tabList" :key="item.code"
          @click="handleItems(item.code)">
          <span>{{ item.name }}</span>
          <img v-show="item.code === active" src="../../assets/images/zone/img2.png" class="icon1" alt="" />
        </div>
      </div>
    </div>
    <div class="block1-list">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="block1-item" v-for="(item, index) in searchList" :key="index" @click="handleClickItems(item)">
          <div class="item-top">
            <img :src="item.iepUserInfoDTO.headPicUrl" class="top-cover" alt="">
            <div class="top-con">
              <div class="txt1">{{ item.iepUserInfoDTO.realName }}</div>
              <div class="txt2">
                <span class="txt2-time">{{ item.times }}</span>
              </div>
            </div>
          </div>
          <div class="con-div">
            <div class="item-title">{{ item.title }}</div>
            <div class="item-cons" v-html="item.content"></div>
            <div class="item-imgs" v-if="item.files.length === 1 && allVideo.indexOf((item.files[0].format).toLocaleLowerCase()) > -1">
              <div class="video-block" v-if="!item.isPlayVideo" @click.stop="handleClickItemsVideo(item, index)">
                <video :src="item.files[0].url" controls class="video"></video>
              </div>
            </div>
            <div class="item-imgs" v-else>
              <div class="imgs-mask" v-if="item.isMoreImgs">
                +{{ item.moreNum }}
              </div>
              <img v-for="(item_img, index_img) in item.files" :key="index_img" :src="item_img.url"
                class="img-cover" alt="">
            </div>
          </div>
          <div class="file-block" v-if="item.filePdf">
            <div class="file-left">文件</div>
            <div class="file-right" @click.stop="handleClick(item.filePdf)">
              {{`${item.filePdf.title}.${item.filePdf.format}`}}
              <img v-if="isTutorAndPeSign" src="../../assets/images/zone/img45.png" class="icon-upload" @click.stop="handleDownLoad(item.filePdf)" alt="">
            </div>
          </div>
          <div class="file-btn" v-if="`${zoneRoles.peSign}` === '1' || `${userInfo.memberType}` === '1'">查看</div>
          <div class="file-btn" v-else-if="!item.approvalWorkNote">去批改</div>
          <div class="file-btn cur-btns" v-else>查看批改</div>
        </div>
      </van-list>
    </div>
    <van-overlay :show="showLoading" @click="showLoading = false">
      <div class="wrapper-loading" @click.stop>
        <van-loading type="spinner" vertical>下载中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { apiWorkList } from '@/api/zone'
import { allVideo, roleIsConsumer, rolesClick } from './data'
import axios from 'axios'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  data () {
    return {
      tabList: [{ code: '', name: '全部' }, { code: '0', name: '待批改' }, { code: '1', name: '已批改' }],
      active: '',
      searchContent: '',
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      type: '',
      load: false,
      searchList: [],
      filePdf: {},
      allVideo,
      showLoading: false
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    zoneRoles () {
      return JSON.parse(sessionStorage.getItem('roleResult'))
    },
    isTutorAndPeSign () {
      return !(`${this.zoneRoles.peSign}` !== '1' && `${this.zoneRoles.tutorSign}` !== '1' && `${this.userInfo.memberType}` !== '1')
    },
  },
  mounted () {
    let role = JSON.parse(sessionStorage.getItem('roleResult'))
    if (roleIsConsumer(role, this.userInfo) || rolesClick(role, this.userInfo)) {
      this.$router.push({
        path: `/zoneDetails?areaId=${this.$route.query.areaId}`
      })
      return
    }
    this.onLoad()
  },
  methods: {
    handleClick(item) {
      const curFileSize = parseFloat(item.size.replace(/[^.\d]/g, ''))
      const curFileFormat = item.size.substring(item.size.length - 2, item.size.length)
      if (curFileSize > 50 && curFileFormat === 'MB') {
        this.$toast('因文件过大，暂不支持预览，已为您下载至本地查看')
        this.handleDownLoad(item)
      } else {
        if (item.url.indexOf('pdf') > -1) {
          this.$router.push({
            path: `/pdfView?pdfUrl=${item.url}&areaId=${this.$route.query.areaId}`
          })
        } else {
          this.$router.push({
            path: `/pptView?pptSrc=${item.url}&areaId=${this.$route.query.areaId}`
          })
        }
      }
    },
    async handleClick12(file) {
      try {
        const response = await axios({
          url: file.url,
          method: 'GET',
          responseType: 'blob', // 必须指定为blob类型才能下载
        })
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
        const link = document.createElement('a')
        link.href = file.url
        let fileName = file.title || 'default_name' // 提供一个默认值以防止 file.title 为 undefined
        let fileFormat = file.format || 'pdf' // 提供一个默认值以防止 file.format 为 undefined
        let encodedFileName = `${encodeURIComponent(fileName)}.${fileFormat}`
        link.setAttribute('download', encodedFileName) // 或者根据实际情况获取文件名
        // link.setAttribute('download', `${file.title}.${file.format}`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url) // 清理内存中的对象URL
      } catch (error) {
        console.error('下载PDF时发生错误:', error)
      }
    },
    onCourseSearchEnter (e) {
      if (e) {
        this.searchContent = e
      }
      this.pageNum = 1
      this.finished = false
      this.searchList = []
      this.onLoad()
      return false
    },
    onLoad () {
      if (this.load) {
        return
      }
      this.load = true
      apiWorkList({
        'postbarId': this.$route.query.postId,
        'searchContent': this.searchContent,
        'checkType': this.active,
        'pageNum': this.pageNum,
        'pageSize': this.pageSize
      }).then(res => {
        this.load = false
        if (res.data.list.length < this.pageSize) {
          this.finished = true
        }
        res.data.list = res.data.list.map(item => {
          item.times = this.$moment(item.createTime * 1).format('MM-DD HH:mm')
          item.files = item.files.filter(items => {
            if (items.format === 'pdf' || items.format.indexOf('ppt') > -1) {
              item.filePdf = items
            }
            return items.format !== 'pdf' && items.format.indexOf('ppt') < 0
          })
          if (item.files.length > 3) {
            item.isMoreImgs = true
            item.moreNum = item.files.length - 3
          }
          item.files = item.files.splice(0, 3)
          return item
        })
        this.searchList = this.searchList.concat(res.data.list)
        // 加载状态结束
        this.loading = false
        if (this.searchList.length <= 0) {
          this.isSearch = true
        } else {
          this.isSearch = false
        }
        this.pageNum++
      })
    },

    handleItems (type) {
      this.type = type
      this.active = type
      this.pageNum = 1
      this.finished = false
      this.searchList = []
      this.onLoad()
    },

    clearSearchValue (e) {
      console.log(e)
      this.onCourseSearchEnter()
    },

    handleClickItems (item) {
      this.$router.push({
        path: `/workDetails?workId=${item.id}&workType=correct&areaId=${this.$route.query.areaId}`
      })
    },
    async handleDownLoad(file) {
      this.showLoading = true
      try {
        const response = await fetch(file.url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/octet-stream'
          }
        })
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        let fileName = file.title || 'default_name' // 提供一个默认值以防止 file.title 为 undefined
        let fileFormat = file.format || 'pdf' // 提供一个默认值以防止 file.format 为 undefined
        let encodedFileName = `${fileName}.${fileFormat}`
        link.setAttribute('download', encodedFileName) // 或者根据实际情况获取文件名
        document.body.appendChild(link)
        link.click()
        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }, 100)
      } catch (error) {
        console.error('Download failed:', error)
      } finally {
        this.showLoading = false
      }
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.work-list {
  min-height: 100vh;
  width: 100%;
  background: #F9F8F7;
  box-sizing: border-box;
}

.details-top {
  width: 100%;
  height: 90px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  background: #F9F8F7;

  .logo-container {
    /deep/ .van-search {
      background-color: transparent;

      .van-search__content {
        background: rgba(255, 255, 255, 0.5);
        border: 1px solid rgba(255, 255, 255, 0.9);
        .van-field__control {
          color: rgb(163, 153, 146);
          &::placeholder {
            color: rgb(163, 153, 146);
          }
        }
      }
    }
  }

  .sec-flex {
    display: flex;
    padding: 0 45px;
    box-sizing: border-box;
    height: 42px;
    align-items: center;
    border-radius: 12px 12px 0 0;
    justify-content: space-between;
    background: #F9F8F7;

    .flex-txt {
      position: relative;
      height: 42px;
      line-height: 42px;
      font-size: 14px;
      color: #656e7f;
      font-weight: 500;
      margin-right: 18px;

      &:nth-last-child(1) {
        margin-right: 0;
      }

      &.cur {
        font-weight: 600;
        color: #EB1700;
      }

      .icon1 {
        position: absolute;
        width: 23px;
        bottom: 4px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}

.block1-list {
  padding: 0 16px;
  padding-top: 106px;
  box-sizing: border-box;
  min-height: 100vh;

  .block1-item {
    background-color: #fff;
    margin-bottom: 10px;
    border-radius: 12px;
    border: 1px solid #fff;
    box-sizing: border-box;
    overflow: hidden;
    padding-bottom: 12px;

    .item-top {
      display: flex;
      align-items: center;
      padding: 10px;
      box-sizing: border-box;
      background: linear-gradient(90.00deg, rgb(241, 239, 237),rgb(255, 255, 255) 100%);
      border-radius: 12px 12px 0 0;

      .top-cover {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        margin-right: 4px;
      }

      .top-con {
        display: flex;
        flex-direction: column;

        .txt1 {
          line-height: 20px;
          font-size: 14px;
          color: #EB1700;
        }

        .txt2 {
          display: flex;
          align-items: center;

          .txt2-tag {
            width: 40px;
            height: 14px;
            border-radius: 2px;
            border: 1px solid #EB1700;
            margin-right: 4px;
            color: #EB1700;
            font-size: 10px;
            text-align: center;
          }

          .txt2-time {
            font-size: 12px;
            font-weight: 500;
            color: #7A8494;
          }
        }
      }
    }

    .con-div {
      padding: 10px;
      padding-bottom: 0;
      box-sizing: border-box;

      .item-title {
        font-size: 14px;
        color: #202020;
        font-weight: 600;
        line-height: 20px;
        margin-bottom: 5px;
      }

      .item-cons {
        font-size: 12px;
        color: #7A8494;
        line-height: 20px;
        margin-bottom: 4px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }

      .item-imgs {
        display: flex;
        position: relative;
        flex-wrap: wrap;

        .video-block {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 200px;
          .video {
            width: 100%;
            display: block;
            height: 200px;
          }
        }

        .img-cover {
          width: 100px;
          margin-right: 10px;
          height: 100px;
          display: block;
          border-radius: 4px;

          &:nth-last-child(1) {
            margin-right: 0;
          }
        }

        .imgs-mask {
          position: absolute;
          right: 0;
          top: 0;
          width: 100px;
          height: 100px;
          background-color: rgba(0, 0, 0, .5);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          color: #fff;
        }

        .video-cover {
          width: 100%;
          height: 152px;
          object-fit: cover;
        }

        .icon-video {
          position: absolute;
          width: 40px;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .item-comment {
        background-color: #F6F6F6;
        padding: 10px 8px;
        box-sizing: border-box;
        margin-top: 10px;
        border-radius: 4px;

        .comment-block {
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          &:nth-last-child(1) {
            margin-bottom: 0;
          }

          .head-cover {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            margin-right: 4px;
            display: block;
          }

          .comment-txt {
            font-size: 12px;
            color: #343434;
          }
        }
      }
    }

    .file-block {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;
      font-size: 14px;
      color: #343434;
      padding: 0 10px;
      box-sizing: border-box;
      .file-left {
        width: 60px;
      }
      .file-right {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 240px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .icon-upload {
          width: 18px;
          height: 18px;
          display: block;
          margin-left: 20px;
        }
      }
    }

    .file-btn {
      width: 100px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      background: #EB1700;
      box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
      border-radius: 100px;
      font-size: 16px;
      color: #fff;
      font-weight: 500;
      float: right;
      margin-right: 10px;
      margin-top: 10px;

      &.cur-btns {
        background: rgba(255, 91, 12, 0.1);
        box-shadow: none;
        color: #EB1700;
      }
    }
  }
}
/deep/.van-overlay {
  z-index: 9;
}
.wrapper-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/workList.vue